import React, {useContext, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../../components/WMS/Mobile/Popup";
import { ReactComponent as Scale } from "assets/img/wms/scale.svg"
import {Grid} from "@mui/material";
import CustomButton from "../../../../../components/CustomButton";
import {FormattedMessage} from "react-intl";
import TextEmphasisBloc from "../../../../../components/WMS/TextEmphasisBloc";
import PrintNode from "../../../../../printNode-js/printnode-ws-http-client";
import {WMSContext} from "../../../context/WMSContext";
import pusherClient from "../../../../../utils/pusherClient";
import {ShipmentMessageSeverity, ShipmentMessageType} from "../../../../../utils/ShipmentMessageType";
import {red500} from "../../../../../assets/jss/main";
import {Link} from "react-router-dom";
import {getShipmentById} from "../../../../../api/shipment/getWithId";

WeighShipmentModal.propTypes = {
    open: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool,
    setIsLoading: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleValidation: PropTypes.func.isRequired,
    shipmentWeigh: PropTypes.number.isRequired,
    setShipmentWeigh: PropTypes.func.isRequired,
    packingStationComputerId: PropTypes.number.isRequired,
    handleToast: PropTypes.func.isRequired,
    packingStep: PropTypes.object.isRequired,
    validPrint: PropTypes.func.isRequired
};

function WeighShipmentModal({open, handleClose, handleValidation, shipmentWeigh = 0, setShipmentWeigh, packingStationComputerId, isLoading = false, setIsLoading, handleToast, packingStep, validPrint}) {
    const {currentOrganization} = useContext(WMSContext)

    const shipmentWeighTimeout = useRef()
    const slipIsPrintedTimeout = useRef()

    const [printNodeWs, setPrintNodeWs] = useState()
    const [errorMessage, setErrorMessage] = useState()

    const currentShipmentChannel = pusherClient.subscribe('shipment-'+packingStep.selectedShipment.shipmentId)

    currentShipmentChannel.bind(ShipmentMessageType.WAYBILL_PRINT_MESSAGE, (data) => handleShipmentMessage(data))

    function handleShipmentWeigh(tempShipmentWeigh) {
        if (shipmentWeigh !== tempShipmentWeigh) {
            clearTimeout(shipmentWeighTimeout.current)
        }
        shipmentWeighTimeout.current = setTimeout(() => {
            // Convert from g to kg
            tempShipmentWeigh = tempShipmentWeigh/1000
            setShipmentWeigh(tempShipmentWeigh)
        }, 2000)
    }

    const handleEdit = (value) => {
        if ("" === value) {
            setShipmentWeigh(value)
            return
        }
       const isValidNumber = (value) => {
           const num = Number(value);
           return !isNaN(num) && num > 0;
       }

       if (isValidNumber(value)) {
           setShipmentWeigh(parseFloat(value))
       } else {
           setShipmentWeigh(value)
       }
    }

    function printNodeAuthenticate (authData)  {
        if (authData.error) {
            handleToast('error')
            return
        }

        var computer = this.getComputerConnections({computerId: packingStationComputerId}, function callBack(computers) {
        })

        var scales = this.getScales({computerId: packingStationComputerId}, function callBack(scalesMeasurement) {
            handleShipmentWeigh(scalesMeasurement.getKilogramMeasurementFromGram().g)
        });
    }

    function printNodeError (err){
        setErrorMessage(err)
    }

    function handleShipmentMessage (data) {
        clearTimeout(slipIsPrintedTimeout.current)
        if (ShipmentMessageSeverity.ERROR === data.severity) {
            setIsLoading(false)
            setErrorMessage(data.message)
        }
        if (ShipmentMessageSeverity.SUCCESS === data.severity) {
            validPrint()
        }
    }

    function handleValid (isReprint = false) {
        handleValidation(isReprint)
        slipIsPrintedTimeout.current = setTimeout(() => {
            getShipmentById(packingStep.selectedShipment.shipmentId).then((response) => {
                if (response.document && response.trackingNumber) {
                    validPrint()
                } else {
                    setIsLoading(false)
                    setErrorMessage(response.error ?? <FormattedMessage id={"wms.packing.modal.shipmentWeigh.defaultErrorMessage"}/>)
                }
            })
        }, 5000)
    }

    useEffect(() => {
        if(shipmentWeigh && shipmentWeigh > 0 && printNodeWs) {
            printNodeWs.closeSocket()
        }
    }, [shipmentWeigh]);

    useEffect(() => {
        if (open && currentOrganization) {
            const printNodeWebSocket = new PrintNode.WebSocket({apiKey: currentOrganization.printNodeKey}, printNodeAuthenticate, printNodeError)
            setPrintNodeWs(printNodeWebSocket)
        }

        if (!open) {
            currentShipmentChannel.unbind(ShipmentMessageType.WAYBILL_PRINT_MESSAGE)
            currentShipmentChannel.unsubscribe('shipment-'+packingStep.selectedShipment.shipmentId)
        }
    }, [open]);

    return (
        <Popup
            open={open}
            onClose={handleClose}
            icon={<Scale/>}
            title={<FormattedMessage id={"wms.packing.modal.shipmentWeigh.title"}/>}
            subtitle={<FormattedMessage id={"wms.packing.modal.shipmentWeigh.subtitle"}/>}
        >
            <Grid container direction={"column"} gap={"16px"}>
                <TextEmphasisBloc
                    title={<FormattedMessage id={"wms.packing.modal.shipmentWeigh.label"}/>}
                    leftPart={shipmentWeigh}
                    rightPart={"kg"}
                    placeholder={<FormattedMessage id={"wms.packing.modal.shipmentWeigh.placeholder"}/>}
                    isEditable={true}
                    editLeftPart={handleEdit}
                />

                {errorMessage && (
                    <Grid container direction={"column"} gap={"8px"}>
                        <Grid container direction={"column"}>
                            <Grid item><FormattedMessage id={"wms.packing.modal.shipmentWeigh.error"}/></Grid>
                            <Grid item sx={{color: red500}}>{errorMessage}</Grid>
                        </Grid>
                        <Grid container direction={"column"}>
                            <Grid item><FormattedMessage id={"wms.packing.modal.shipmentWeigh.toOMS"}/></Grid>
                            <Grid item>
                                <Link target="_blank" to={"../picking/orders/show/"+packingStep.selectedShipment.orderId}><FormattedMessage id={"wms.packing.modal.shipmentWeigh.toOMS.link"}/></Link>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <CustomButton
                                loading={isLoading}
                                disabled={isLoading}
                                onClick={() => handleValid(true)}
                                fullWidth
                                color={"default"}
                                style={{marginTop: "8px"}}
                            >
                                {!isLoading ?
                                    <FormattedMessage id={"wms.packing.modal.scanDropZone.printButton"}/> :
                                    <FormattedMessage id={"wms.packing.modal.scanDropZone.printButton.isLoading"}/>
                                }

                            </CustomButton>
                        </Grid>
                    </Grid>
                )}

                {shipmentWeigh > 0 && !errorMessage && (
                    <Grid item>
                        <CustomButton
                            loading={isLoading}
                            disabled={isLoading}
                            onClick={() => handleValid()}
                            fullWidth
                        >
                            {!isLoading ?
                                <FormattedMessage id={"wms.packing.modal.shipmentWeigh.validButton"}/> :
                                <FormattedMessage id={"wms.packing.modal.shipmentWeigh.validButton.isLoading"}/>
                            }
                        </CustomButton>
                    </Grid>
                )}
            </Grid>
        </Popup>
    );
}

export default WeighShipmentModal;